import { Component, Input, ViewChild } from '@angular/core';
import { isDate } from 'date-fns';

import { TaskItem } from '../../../../core';
import { focusItem } from '../../function/focus-item.function';
import { ViewTaskItem } from '../../model/view-task-item.model';
import { TaskListDialogService } from '../../task-list-dialog.service';
import { taskItemTransformer } from '../../transformer/task-item.transformer';
import {
    IMPORTANCE_NORMAL,
    STATUS_NOT_STARTED,
    viewTaskItemTransformer,
} from '../../transformer/view-task-item.transformer';
import { TaskPropsComponent } from '../task-props/task-props.component';
import { TaskTitleComponent } from '../task-title/task-title.component';

import { TranslationKeyMap } from './new-task.component.i18n';

@Component({
    selector: 'cmps-task-list-new-task',
    templateUrl: './new-task.component.html',
    host: {
        class: 'cmps-task-list-new-task cmps-cdk-d-flex cmps-cdk-bg-color-white cmps-cdk-border-radius-5px',
        '[class.cmps-cdk-flex-column]': '_willAdd === true',
    },
})
export class NewTaskComponent {
    @Input() dataContainerValue: string;

    @ViewChild(TaskTitleComponent)
    private readonly _titleRef: TaskTitleComponent;

    @ViewChild(TaskPropsComponent)
    private readonly _propsRef: TaskPropsComponent;

    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _willAdd: boolean;

    /** @private */
    _item: ViewTaskItem;

    constructor(/** @private */ readonly _service: TaskListDialogService) {}

    /** @private */
    _onWillAddClick(): void {
        const task: TaskItem = {
            msftTaskId: 'new-task',
            title: null,
            importance: IMPORTANCE_NORMAL,
            status: STATUS_NOT_STARTED,
            createdDateTime: null,
            dueDateTime: new Date(),
        };
        this._item = viewTaskItemTransformer([task])[0];
        this._willAdd = true;

        focusItem(
            `[data-container="${this.dataContainerValue}"] [data-task="${
                this._item.msftTaskId ?? 'unknown'
            }"]`,
        );
    }

    /** @private */
    _onMarkerClick(): void {
        this._item.completed = this._item.completed !== true;
        this._update();
    }

    /** @private */
    _onDueDateTimeChange(dueDateTime: Date | null): void {
        let next: Date | null;
        if (dueDateTime != null && !isDate(dueDateTime)) {
            next =
                this._item.dueDateTime == null ? null : this._item.dueDateTime;
        } else {
            next = !isNaN(dueDateTime?.getTime()) ? dueDateTime : null;
        }
        if (this._item.dueDateTime === next) {
            // revert the invalid date without going through the reducer
            this._propsRef?.dueDateTimeRef?.writeValue(this._item.dueDateTime);
            return;
        }
        this._item.dueDateTime = next;
        this._update();
    }

    _onImportanceClick(): void {
        this._item.important = this._item.important !== true;
        this._update();
    }

    /** @private */
    _onDeleteClick(): void {
        this._willAdd = false;
    }

    /** @private */
    _onAddClick(): void {
        this._item.title = this._titleRef.nextTitle ?? this._item.title;

        const item = taskItemTransformer([this._item])[0];
        this._item = viewTaskItemTransformer([item])[0];

        void this._service.taskStatusService.create(item);

        this._willAdd = false;
    }

    private _update(): void {
        const item = taskItemTransformer([this._item])[0];
        this._item = viewTaskItemTransformer([item])[0];
    }
}
